import { Button, Spin } from 'antd'
import { AnimatePresence, motion } from 'framer-motion'
import { useEffect, useRef, useState } from 'react'
import { cn } from '../utils/helper'

type Props = {
    className?: string
    isLoading?: boolean
    refresh?: () => void
}

const AnimatedButton = motion(Button)

export default function LoadingSpinner({ className, isLoading, refresh }: Props) {
    const [isShowingReset, setIsShowingReset] = useState(false)
    const [reset, setReset] = useState(false)

    let timeoutId = useRef<any>()

    useEffect(() => {
        if (isLoading) {
            clearTimeout(timeoutId.current)
            timeoutId.current = setTimeout(() => {
                setIsShowingReset(true)
            }, 5000)
        } else {
            setIsShowingReset(false)
        }

        return () => {
            clearTimeout(timeoutId.current)
        }
    }, [isLoading, refresh, reset])

    function handleRefresh() {
        setReset((prev) => !prev)
        setIsShowingReset(false)
        refresh?.()
    }

    return (
        <div className={cn('flex w-full flex-col items-center gap-3', className)}>
            <Spin />
            <AnimatePresence>
                {isShowingReset && (
                    <AnimatedButton
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{
                            opacity: 0,
                            y: 20
                        }}
                        type="primary"
                        onClick={handleRefresh}
                        className="text-xl"
                    >
                        Refresh data
                    </AnimatedButton>
                )}
            </AnimatePresence>
        </div>
    )
}
